<script>
import { Doughnut } from 'vue-chartjs'

export default {
  props: ['progress', 'max'],
  extends: Doughnut,

  methods: {
      convertData() {
        const chartData = {
            labels: [],
            datasets: [{
                label: 'Compute usage',
                data:  [this.progress, this.max - this.progress],
                backgroundColor: [
                    '#665191',
                    '#dae1e7',
                    '#d45087',
                    '#f95d6a'],
                }]
        }
        const chartOptions = {
            cutoutPercentage: 85,
            // rotation: Math.PI / 2,
            legend: {
                display: false,
            },
            tooltips: {
                filter: tooltipItem => tooltipItem.index == 0
            }
        }
        this.renderChart(chartData, chartOptions);
      },
},


  mounted() {
    // this.addPlugin({
    //     id: 'my-plugin',
    //     beforeDraw: (chart) => {
    //         var width = chart.chart.width;
    //         var height = chart.chart.height;
    //         var ctx = chart.chart.ctx;

    //         ctx.restore();
    //         ctx.textBaseline = "middle";
    //         ctx.font =  "16px sans-serif";
    //         let data = []
    //         this.inUseData.forEach(item => {
    //             if (this.component === 'compute') {
    //                 data.push(item.instances.in_use);
    //             } else if (this.component === 'volume') {
    //                 data.push(item.volumes.in_use);
    //             } else {
    //                 data.push(item.network.used);
    //             }
    //         })
    //         var text = 'AMS: ' + data[0] + ' - FRA: ' + data[1];

    //         var textX = Math.round((width - ctx.measureText(text).width) / 1.35);
    //         var textY = height / 2;

    //         ctx.fillText(text, textX, textY);
    //         ctx.save();
    //     }
    // })
      this.convertData();
  },
}
</script>
